module.exports = __webpack_public_path__ + "c99c0a71025bf0a9195b84e2271c0482.svg";